import { faEdit, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, DatePicker, Form, Select } from 'antd';
import Search from 'antd/lib/input/Search';
import { API } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { GetMessagesStatQuery, MessageCategory } from '../../../API';
import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { getMessagesStat } from '../../../graphql/queries';
import { FormattedMessage, useIntl } from 'react-intl';

export type Filter = {
	category: string | null;
	text: string | null;
	dateStart: string | null;
	dateEnd: string | null;
};

type MessageFilterProps = {
	onRefresh?: () => void;
	onFilter?: (filter: Filter) => void;
	updateCounter?: boolean;
	onNewMessageClick?: () => void;
};

const MessagesFilter: React.FC<MessageFilterProps> = ({ onFilter, onRefresh, updateCounter, onNewMessageClick }) => {
	const [filterCategory, setFilterCategory] = useState<string>('');
	const [filterText, setFilterText] = useState<string>('');
	const [dateFilter, setDateFilter] = useState<string[]>(['', '']);
	const [newMessages, setNewMessages] = useState<number>(0);

	const aCategories = Object.values(MessageCategory);
	const { Option } = Select;
	const intl = useIntl();
	useEffect(() => {}, []);

	useEffect(() => {
		(async () => {
			const result: GraphQLResult<GetMessagesStatQuery> = (await API.graphql({
				query: getMessagesStat,
				authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
				variables: {}
			})) as GraphQLResult<GetMessagesStatQuery>;
			if (result.data.getMessagesStat.readedMessages)
				setNewMessages(result.data.getMessagesStat.newMessages - result.data.getMessagesStat.readedMessages);
			else setNewMessages(result.data.getMessagesStat.newMessages);
		})();
	}, [updateCounter]);

	return (
		<Form>
			<div className="d-flex f-column ">
				<div className="d-flex f-row messages-filter-head f-space-beetween align-items-center">
					<div className="new-messages btn-action">{newMessages}</div>
					<div>{intl.formatMessage({ id: 'new' })}</div>
					<Button
						className="btn-action"
						onClick={() => {
							if (onNewMessageClick) onNewMessageClick();
						}}
					>
						<FontAwesomeIcon icon={faEdit} />
						&nbsp;&nbsp;{intl.formatMessage({ id: 'message.new' })}
					</Button>
				</div>
				<div className="mt-1">
					<Search
						placeholder={intl.formatMessage({ id: 'input.search.text' })}
						value={filterText}
						onChange={v => {
							setFilterText(v.target.value);
						}}
					/>
				</div>
				<div className="mt-1">
					<DatePicker.RangePicker
						onChange={v => {
							setDateFilter([v[0].toISOString(), v[1].toISOString()]);
						}}
					/>
				</div>

				<Select
					className="mt-1"
					onChange={v => {
						setFilterCategory(v);
					}}
					value={filterCategory}
				>
					<Option value="">{''}</Option>
					{aCategories.map((c, i) => {
						return (
							<Option key={`opt-${i}`} value={c}>
								<FormattedMessage id={c} />
							</Option>
						);
					})}
				</Select>
				<div className="d-flex row mt-1" style={{ justifyContent: 'flex-end' }}>
					<Button
						className="ant-btn-thirdy mr-1"
						onClick={() => {
							setFilterCategory('');
							setDateFilter(['', '']);
							setFilterText('');

							if (onRefresh) onRefresh();
						}}
					>
						<FontAwesomeIcon icon={faRefresh} />
					</Button>
					<Button
						className="ant-btn-secondary"
						onClick={() => {
							console.log(dateFilter);
							const f: Filter = {
								category: filterCategory,
								dateStart: dateFilter[0],
								dateEnd: dateFilter[1],
								text: filterText
							};
							if (onFilter) onFilter(f);
						}}
					>
						{intl.formatMessage({ id: 'filter' })}
					</Button>
				</div>
			</div>
		</Form>
	);
};

export default MessagesFilter;
